<style lang="postcss">
	.nps-cover-1 {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
	.nps-cover-2 {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.nps-cover-xs {
		width: 100%;
		flex-direction: row;
		justify-content: stretch;
		display: none;
		flex-direction: column;
		align-items: center;
	}
	.nps-cover-noxs {
		width: 100%;
		flex-direction: row;
		justify-content: stretch;
		display: flex;
		gap: 3px;
	}
	.nps-block {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: center;
	}
	.footer-labels {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		font-size: 0.75rem;
		margin-top: 0.25rem;
		height: 1.25rem;
		flex-wrap: nowrap;
		opacity: 0.4;
	}
	@container (max-width: 32rem) {
		.nps-cover-1 {
			align-items: flex-start;
		}
	}
	@container (max-width: 20rem) {
		.nps-block {
		}
		.nps-block-1 {
			width: 100%;
		}
		.nps-block-2 {
			width: 83.33%;
		}
		.nps-cover-xs {
			display: flex;
		}
		.nps-cover-noxs {
			display: none;
		}
	}
</style>

<script lang="ts">
	import NpsItem from "./NPSItem.svelte";
	import { BROWSER } from "esm-env";
	import { createEventDispatcher, onDestroy, onMount } from "svelte";

	export let name: string = "";
	export let value: string | undefined = undefined;
	export let disabled: boolean = false;
	export let leftLabel: string = "";
	export let rightLabel: string = "";

	let inputRef: HTMLDivElement;

	const dispatch = createEventDispatcher();

	let numbers = Array.from({ length: 11 }, (_, i) => i);
	let show = false;
	let position: number = 0;
	let height: number;
	let width: number;
	let wasClicked = false;
	let borderColor = "#fff";

	const mouseover = (e: MouseEvent) => {
		show = true;
		const item = (e.target as HTMLElement).closest(".item");
		if (!item) return;
		// Get position relative to the element
		const parentLeft = inputRef.getBoundingClientRect().left;
		position = item.getBoundingClientRect().left - parentLeft;
		height = item.getBoundingClientRect().height;
		width = item.getBoundingClientRect().width;
		updateBorderColor(item);
	};

	const updateBorderColor = (item: Element) => {
		if (!item) return;
		const content = parseInt(item.textContent?.trim() ?? "0");
		const styles = getComputedStyle(item);
		borderColor = styles.getPropertyValue("background-color");
		if (content < 7) {
			borderColor = "#f9606a";
		} else if (content < 9) {
			borderColor = "#e29d41";
		} else {
			borderColor = "#3ba476";
		}
	};

	const updatePositionBasedOnChecked = () => {
		if (typeof value === "undefined") return;
		const checked = inputRef.querySelector("input[value='" + value + "']");
		if (!checked) return;
		const item = checked.closest(".item");
		if (!item) return;
		show = true;
		const parentLeft = inputRef.getBoundingClientRect().left;
		position = item.getBoundingClientRect().left - parentLeft;
		updateBorderColor(item);
	};

	$: {
		value;
		if (inputRef) updatePositionBasedOnChecked();
	}

	const mouseleave = (e: MouseEvent) => {
		if (typeof value === "undefined") {
			show = false;
		} else {
			updatePositionBasedOnChecked();
		}
	};

	const clickElement = (e: MouseEvent) => {
		dispatch("click");
		wasClicked = true;
	};

	onMount(() => {
		if (!BROWSER) return;
		inputRef.addEventListener("mouseover", mouseover);
		inputRef.addEventListener("mouseleave", mouseleave);
		inputRef.addEventListener("click", clickElement);
		// get first .item in inputRef
		const item = inputRef.querySelector(".item");
		if (item) {
			height = item.getBoundingClientRect().height;
			width = item.getBoundingClientRect().width;
		}
	});

	onDestroy(() => {
		if (!BROWSER) return;
		inputRef.removeEventListener("mouseover", mouseover);
		inputRef.removeEventListener("mouseleave", mouseleave);
		inputRef.removeEventListener("click", clickElement);
	});
</script>

{#if true === true}
	<div class="nps-cover-1 {$$props.class || ''}" bind:this="{inputRef}">
		<div class="nps-cover-2">
			<div class="nps-cover-xs">
				<div class="nps-block nps-block-1">
					{#each numbers.slice(0, 6) as number}
						<NpsItem
							disabled="{disabled}"
							name="{name}"
							number="{number}"
							bind:value="{value}" />
					{/each}
				</div>
				<div class="nps-block nps-block-2">
					{#each numbers.slice(6) as number}
						<NpsItem
							disabled="{disabled}"
							name="{name}"
							number="{number}"
							bind:value="{value}" />
					{/each}
				</div>
			</div>
			<div class="nps-cover-noxs">
				{#each numbers as number}
					<NpsItem
						disabled="{disabled}"
						name="{name}"
						number="{number}"
						bind:value="{value}" />
				{/each}
			</div>
			{#if leftLabel || rightLabel}
				<div class="footer-labels">
					{#if leftLabel}
						<div style="text-align: left">{leftLabel}</div>
					{/if}
					{#if rightLabel}
						<div style="text-align: right">{rightLabel}</div>
					{/if}
				</div>
			{/if}
		</div>
	</div>
{/if}
